import React, {Component, Fragment} from 'react';

class Card extends Component {

	constructor(props) {
		super(props);
	}

	render() {

		return (
			<div className="card border-top border-3 border-top-primary">
				<div className="card-body" style={{padding : "11px 20px"}}>
					<h5 className="text-muted mb-1">
						{this.props.title}
						{/* <div className="metric-value d-inline-block float-right">
							<h5 className="mb-1">
								{
									this.props.rate != null ? <ArrowInfo rate={this.props.rate} isRate={this.props.isRate == null ? true : this.props.isRate} /> : null
								}
							</h5>
						</div> */}
					</h5>
                    <div className="text-right">
						<h4 className="mb-1">{this.props.value}</h4>
                    </div>
                    {(this.props.isRate === true) ? (
                        <div className="">
                            <div className="progress progress-lg text-center" style={{background:"#8c8c8c"}}>
                                <span className="progress-value">{this.props.rate + "%"}</span>
                                <div className="progress-bar" role="progressbar" style={{width: this.props.rate+"%"}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"/>
                            </div>
                        </div>
                    ): (
                        <div className="mb-3">
                        </div>
                    )
                    }
				</div>
			</div>
		)
		
		
	}

}

export default class BranchCards extends Component {

	render() {

		return (
			<Fragment>
				<div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                    <Card title="전체" value={this.props.branch == null ? '-' : this.props.branch.contract[this.props.year].TOTAL.toLocaleString() + ' 건'} isRate={false} />
				</div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                    <Card title="신규" value={this.props.branch == null ? '-' : this.props.branch.contract[this.props.year].TOTAL_NEW.toLocaleString() + ' 건'} isRate={false} />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                    <Card title="재계약" value={this.props.branch == null ? '-' : this.props.branch.contract[this.props.year].TOTAL_RENEW.toLocaleString() + ' 건'} isRate={false} />
                </div>
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 col-12">
                    <Card title="직전년 대비 성장률" value={this.props.branch == null ? '-' : this.props.branch.contract[this.props.year].RATE_GROWTH.toLocaleString() + ' %'} isRate={false} />
                </div>
			</Fragment>
		)
	}
}

